import { Component, OnInit, inject } from '@angular/core';
import {RegioverantwoordelijkeService} from '../../../regioverantwoordelijke/regioverantwoordelijke.service';
import {Observable, Subject} from 'rxjs';
import {Regioverantwoordelijke} from '../../../regioverantwoordelijke/regioverantwoordelijke';
import {Page} from '../../../core/pagination/page';
import {PageRequest} from '../../../core/pagination/page-request';
import {SortOrder} from '../../../core/sort/sort-order';
import {Router} from '@angular/router';
import {DialogService} from '../../../core/dialog/dialog.service';
import {filter, mergeMap, tap} from 'rxjs/operators';

@Component({
    templateUrl: './regioverantwoordelijken.page.html',
    styleUrls: ['./regioverantwoordelijken.page.scss'],
    standalone: false
})
export class RegioverantwoordelijkenPage implements OnInit {
  private regioverantwoordelijkeService = inject(RegioverantwoordelijkeService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  initialPageRequest: PageRequest<Regioverantwoordelijke> = PageRequest.firstPageRequest<Regioverantwoordelijke>(SortOrder.ASCENDING, 5);
  regioverantwoordelijkenPage$: Subject<Page<Regioverantwoordelijke>> = new Subject<Page<Regioverantwoordelijke>>();
  private currentPageRequest: PageRequest<Regioverantwoordelijke>;

  ngOnInit(): void {
    this.getRegioverantwoordelijken$(this.initialPageRequest).subscribe();
  }

  navigateToRegioverantwoordelijke(regioverantwoordelijke: Regioverantwoordelijke): void {
    this.router.navigateByUrl(`/regioverantwoordelijken/${regioverantwoordelijke.getId()}`);
  }

  deleteRegioverantwoordelijke(regioverantwoordelijke: Regioverantwoordelijke): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${regioverantwoordelijke.getVoornaam()} wil verwijderen?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.regioverantwoordelijkeService.deleteRegioverantwoordelijke$(regioverantwoordelijke.getId())),
        mergeMap(() => this.getRegioverantwoordelijken$(this.currentPageRequest.toFirstPage())),
      )
      .subscribe();
  }

  navigateToAddRegioverantwoordelijke(): void {
    this.router.navigateByUrl('/regioverantwoordelijken/toevoegen');
  }

  onPageChange(pageRequest: PageRequest<Regioverantwoordelijke>): void {
    this.getRegioverantwoordelijken$(pageRequest).subscribe();
  }

  private getRegioverantwoordelijken$(pageRequest: PageRequest<Regioverantwoordelijke>): Observable<Page<Regioverantwoordelijke>> {
    this.currentPageRequest = pageRequest;
    return this.regioverantwoordelijkeService
      .getRegioverantwoordelijken$(pageRequest)
      .pipe(tap(page => this.regioverantwoordelijkenPage$.next(page)));
  }
}
